/*
 * Authors: mariushirjanu
 * Created: 08/07/2024
 */

import { Injectable } from '@angular/core';

export const ACCREDITATION_TYPE_C:string = 'C'; // Company Accreditations
export const ACCREDITATION_TYPE_E:string = 'E'; // Engineer Accreditations
export const ACCREDITATION_TYPE_CE:string = 'C,E'; // include both by default (Vendor Company Accreditations & Engineer Accreditations)

@Injectable()
export class BPProfilesAccreditationsService {
  private _accreditationType:string;

  public get accreditationType():string {
    return this._accreditationType;
  }

  public set accreditationType(type:string) {
    this._accreditationType = type;
  }

  public clear():void {
    this._accreditationType = undefined;
  }
}
